import { translate, translateFormatter } from '@/core/localization/translate';
export const {
  atStreet,
  roomOfChoice,
  preOrderRoomOfChoice,
  homeDeliveryH24,
  homeDeliveryH48,
  homeDelivery,
  pickUpDelivery,
  pickUpDeliveryH24,
  pickUpDeliveryH48,
  freeDelivery,
  claimDeliveryFree,
  deliveryOptionsAvailable,
  deliveryOptionsAvailableAndReturns,
  deliveryWith,
  deliveryAndReturns,
  deliveryWording,
  returnWording
} = translate({
  "atStreet": "By appointment outside your home",
  "roomOfChoice": "Home delivery to the room of your choice",
  "preOrderRoomOfChoice": "By appointment to the room of your choice",
  "homeDeliveryH24": "Home delivery in 24h",
  "homeDeliveryH48": "Home delivery in 48h",
  "homeDelivery": "At home",
  "pickUpDelivery": "At a pick-up point",
  "pickUpDeliveryH24": "Pick-up point delivery in 24h",
  "pickUpDeliveryH48": "Pick-up point delivery in 48h",
  "freeDelivery": "Free shipping",
  "claimDeliveryFree": "Free",
  "deliveryOptionsAvailable": "Delivery",
  "deliveryOptionsAvailableAndReturns": "Delivery and returns",
  "deliveryWith": "with",
  "deliveryAndReturns": "Delivery and returns",
  "deliveryWording": "Delivery",
  "returnWording": "Return"
});
export const onDateDelivery = translateFormatter<{
  day: string;
  month: string;
}>("On {day} {month}", undefined, undefined, "en");
export const betweenDatesDeliveryWithSameMonth = translateFormatter<{
  dayMin: string;
  dayMax: string;
  monthMax: string;
}>("Between {dayMin} and {dayMax} {monthMax}", undefined, undefined, "en");
export const betweenDatesDeliveryWithDiffMonth = translateFormatter<{
  dayMin: string;
  dayMax: string;
  monthMin: string;
  monthMax: string;
}>("Between {dayMin} {monthMin} and {dayMax} {monthMax}", undefined, undefined, "en");
export const betweenDatesDeliveryWithDiffYear = translateFormatter<{
  dayMin: string;
  dayMax: string;
  monthMin: string;
  monthMax: string;
  yearMin: number;
  yearMax: number;
}>("Between {dayMin} {monthMin} {yearMin} and {dayMax} {monthMax} {yearMax}", undefined, undefined, "en");
export const beforeTimeDelivery = translateFormatter<{
  hours: string;
  minutes: string;
}>("for any order placed before {hours}:{minutes}", undefined, undefined, "en");
export const preOrderScheduledDelivery = translateFormatter<{
  fromDay: number;
  fromMonth: string;
}>("From {fromMonth} {fromDay}", undefined, undefined, "en");
export const optionsAvailable = translateFormatter<{
  offers: number;
}>("{offers} available options", undefined, undefined, "en");